import React from 'react';

interface ISalariedIcon {
  size?: number;
  fill?: string;
}

const SalariedIcon: React.FC<ISalariedIcon> = props => {
  const { size = 12, fill = '#3B64F4' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2606_70889)">
        <path
          d="M10.2857 3.42858H8.57143C8.5146 3.42858 8.46009 3.406 8.41991 3.36582C8.37972 3.32563 8.35714 3.27113 8.35714 3.21429V2.57144C8.35714 1.94628 8.1088 1.34674 7.66675 0.904686C7.2247 0.462636 6.62515 0.214294 6 0.214294C5.37485 0.214294 4.7753 0.462636 4.33325 0.904686C3.8912 1.34674 3.64286 1.94628 3.64286 2.57144V3.21429C3.64286 3.27113 3.62028 3.32563 3.58009 3.36582C3.53991 3.406 3.4854 3.42858 3.42857 3.42858H1.71429C1.25963 3.42858 0.823594 3.60919 0.502103 3.93068C0.180612 4.25217 0 4.68821 0 5.14287L0 10.2857C0 10.7404 0.180612 11.1764 0.502103 11.4979C0.823594 11.8194 1.25963 12 1.71429 12H10.2857C10.7404 12 11.1764 11.8194 11.4979 11.4979C11.8194 11.1764 12 10.7404 12 10.2857V5.14287C12 4.68821 11.8194 4.25217 11.4979 3.93068C11.1764 3.60919 10.7404 3.42858 10.2857 3.42858V3.42858ZM4.5 9.21429C4.5 9.38479 4.43227 9.5483 4.31171 9.66886C4.19115 9.78942 4.02764 9.85715 3.85714 9.85715C3.68665 9.85715 3.52313 9.78942 3.40257 9.66886C3.28202 9.5483 3.21429 9.38479 3.21429 9.21429V6.21429C3.21429 6.0438 3.28202 5.88028 3.40257 5.75973C3.52313 5.63917 3.68665 5.57144 3.85714 5.57144C4.02764 5.57144 4.19115 5.63917 4.31171 5.75973C4.43227 5.88028 4.5 6.0438 4.5 6.21429V9.21429ZM7.07143 3.21429C7.07143 3.27113 7.04885 3.32563 7.00867 3.36582C6.96848 3.406 6.91398 3.42858 6.85714 3.42858H5.14286C5.08603 3.42858 5.03152 3.406 4.99133 3.36582C4.95115 3.32563 4.92857 3.27113 4.92857 3.21429V2.57144C4.92857 2.28728 5.04145 2.01475 5.24239 1.81382C5.44332 1.61289 5.71584 1.50001 6 1.50001C6.28416 1.50001 6.55668 1.61289 6.75761 1.81382C6.95855 2.01475 7.07143 2.28728 7.07143 2.57144V3.21429ZM8.78571 9.21429C8.78571 9.38479 8.71798 9.5483 8.59743 9.66886C8.47687 9.78942 8.31335 9.85715 8.14286 9.85715C7.97236 9.85715 7.80885 9.78942 7.68829 9.66886C7.56773 9.5483 7.5 9.38479 7.5 9.21429V6.21429C7.5 6.0438 7.56773 5.88028 7.68829 5.75973C7.80885 5.63917 7.97236 5.57144 8.14286 5.57144C8.31335 5.57144 8.47687 5.63917 8.59743 5.75973C8.71798 5.88028 8.78571 6.0438 8.78571 6.21429V9.21429Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2606_70889">
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SalariedIcon;
